import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setContent, setIsOpenContentsModal } from "../../redux/contentSlice";
import { useNavigate } from "react-router-dom";
import "../../global.css";
import "./contentCard.css";

const ContentCard = ({ item, isHome = false, isMobile = false }) => {
  const { language } = useSelector((state) => state.language);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isHoveredTitle, setIsHoveredTitle] = useState(false);
  const [isHoveredAltTitle, setIsHoveredAltTitle] = useState(false);

  const { content } = useSelector((state) => state.content);

  const handleAltContent = (item) => {
    const newItem = {
      id: item.altId,
      title: item.altTitle,
      subTitle: item.altSubTitle,
      description: item.altDescription,
      image: item.altImage,
      url: item.altUrl,
    };
    dispatch(setContent(newItem));
    navigate("/");
    dispatch(setIsOpenContentsModal(false));
  };

  return (
    <div className="contentsDivStyle">
      <span
        className="textMono contentsTitleStyle"
        style={{
          color:
            content?.title === item?.title || isHoveredTitle === true
              ? "#EF4536"
              : "#100F0D",
          cursor: "pointer",
        }}
        onClick={() => {
          dispatch(setContent(item));
          navigate(
            isHome === false
              ? item.id === 1
                ? "/visualnarratives"
                : item.id === 2
                ? "/auditorynarratives"
                : item.id === 3
                ? "/textualnarratives"
                : "/"
              : "/"
          );
          if (isMobile === true) {
            dispatch(setIsOpenContentsModal(false));
          }
        }}
        onMouseEnter={() => setIsHoveredTitle(true)}
        onMouseLeave={() => setIsHoveredTitle(false)}
      >
        {language.value === "tr"
          ? item?.title.toLocaleUpperCase("tr-TR")
          : item?.title.toLocaleUpperCase("en-US")}
      </span>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          maxHeight: "100px",
          gap: "-3px",
        }}
      >
        <img
          onClick={() => {
            dispatch(setContent(item));
            navigate(
              isHome === false
                ? item.id === 1
                  ? "/visualnarratives"
                  : item.id === 2
                  ? "/auditorynarratives"
                  : item.id === 3
                  ? "/textualnarratives"
                  : "/"
                : "/"
            );
            if (isMobile === true) {
              dispatch(setIsOpenContentsModal(false));
            }
          }}
          className="contentsImageStyle"
          style={{
            filter:
              item?.altTitle !== undefined && item?.title !== content?.title
                ? "grayscale(100%)"
                : content?.id !== item?.id && "grayscale(100%)",
            height: item?.altImage !== undefined && "6vh",
            maxHeight: item?.altImage !== undefined && "50px",
            borderBottomLeftRadius: item?.altImage !== undefined && "0px",
            borderBottomRightRadius: item?.altImage !== undefined && "0px",
          }}
          alt=""
          src={`/assets/images/${item?.image}`}
        />
        {item?.altImage !== undefined && (
          <img
            onClick={() => {
              handleAltContent(item);
            }}
            className="contentsImageStyle"
            style={{
              filter: content?.id !== item?.altId && "grayscale(100%)",
              height: item?.altImage !== undefined && "6vh",
              maxHeight: item?.altImage !== undefined && "50px",
              borderTopLeftRadius: item?.altImage !== undefined && "0px",
              borderTopRightRadius: item?.altImage !== undefined && "0px",
            }}
            alt=""
            src={`/assets/images/${item?.altImage}`}
          />
        )}
      </div>
      {item?.altTitle && (
        <span
          className="textMono contentsTitleStyle"
          style={{
            color:
              content?.id === item?.altId || isHoveredAltTitle === true
                ? "#EF4536"
                : "#100F0D",
            cursor: "pointer",
          }}
          onMouseEnter={() => setIsHoveredAltTitle(true)}
          onMouseLeave={() => setIsHoveredAltTitle(false)}
          onClick={() => handleAltContent(item)}
        >
          {item?.altTitle}
        </span>
      )}
    </div>
  );
};

export default ContentCard;
